/**
 * Fabio Jr.
 * Classe para manter as preferencias do Usuario
 */


Greenmile.UserPreferences = Greenmile.UserPreferences || {};

Greenmile.UserPreferences.Actions = function () {

    const gmStorage = new Greenmile.Storage.StoreMapPosition();

    this.clearLocalStorage = () => {

        const gmVersion = Monet.Session.sessionStorage.GMLocalStorageVersion || "";

        Monet.Session.sessionStorage.clear();
        Monet.Session.sessionStorage.setItem('GMLocalStorageVersion', gmVersion);
    };

    this.setDefaultPreferences = () => {

        const listDefault = Greenmile.UserPreferences.Default.getDefaultPreferences();

        for (var key in listDefault) {
            Monet.Session.sessionStorage.setItem(key, JSON.stringify(listDefault[key]));
        }

    };

    this.setPreferencesAfterLogin = (data) => {

        this.clearLocalStorage();
        this.setDefaultPreferences();

        data = data || [];

        data.forEach((item) => {

            Monet.Session.UserPreferences[item.id] = item;
            Monet.Session.sessionStorage.setItem(item.key, item.json || '');
        });

        gmStorage.setIsUpdated();

    };

    this.updatePreferenceInSession = (data) => {
        const featuresStates = GreenmileReduxStore.getState().features;

        const liveMetadataIsEnabled = featuresStates.has('LIVE_METADATA') && 
            featuresStates.get('LIVE_METADATA')?.enabled;

        liveMetadataIsEnabled && data.forEach(preferenceData => {
            const preferenceId = preferenceData?.id;
            const preferenceInSession = Monet.Session.UserPreferences[preferenceId];
    
            if (!preferenceInSession) {
                Monet.Session.UserPreferences[preferenceId] = preferenceData;
            }
        })
    };

    this.getListPreferenceToSaveOrUpdate = () => {

        const dataOnStorage = Monet.Session.sessionStorage;
        const dataOnUserPreferenceSession = Monet.Session.UserPreferences;
        const listPreference = [];

        for (var key in dataOnStorage) {

            var exists = false;

            if (key !== 'isUpdated' &&
                key !== 'setItem' && key !== 'getItem' && key !== 'clear') {

                for (var preferenceId in dataOnUserPreferenceSession) {

                    var preference = dataOnUserPreferenceSession[preferenceId];

                    if (key === preference.key) {

                        preference.json = dataOnStorage[preference.key];
                        listPreference.push(preference);
                        exists = true;
                        break;

                    }

                }

                if (!exists) {
                    listPreference.push({
                        user: {
                            id: Monet.Session.User.id
                        },
                        key: key,
                        json: dataOnStorage[key]
                    });
                }

            }

        }

        return listPreference;

    };

    this.saveOrUpdateSingleUserPreference = (preferenceName) => {
        const request = new Greenmile.UserPreferences.Requests();
        const list = this.getListPreferenceToSaveOrUpdate();

        const preference = list.filter(item => item.key === preferenceName);

        request.setPreferencesByBatch(preference, this.updatePreferenceInSession);
    }

    this.removeUnusedValuesInPreferences = (preferences) => {

        for(let index in preferences){
            const preference = preferences[index];

            if(preference.key === 'POIs') {
                const POIs = JSON.parse(preference.json);
                const sanityzedPOIs = POIs.filter(POI => POI.value === true);
                preferences[index].json = JSON.stringify(sanityzedPOIs);
            }

            if(preference.key === 'geofenceTag'){
                const geofenceTags = JSON.parse(preference.json);

                for(let tagIndex in geofenceTags) {
                    const tag = geofenceTags[tagIndex];
                    
                    if(tag.length >= 1) {
                        const sanityzedTags = tag.filter(item => item.value === true);
                        geofenceTags[tagIndex] = sanityzedTags;
                    } else {
                        delete geofenceTags[tagIndex];
                    }

                    preferences[index].json = JSON.stringify(geofenceTags);
                }
            }
        }

        return preferences;
    };

    this.saveOrUpdateUserPreferences = (callback) => {

        const request = new Greenmile.UserPreferences.Requests();
        const list = this.getListPreferenceToSaveOrUpdate();
        const sanityzedList = this.removeUnusedValuesInPreferences(list);

        request.setPreferencesByBatch(sanityzedList, callback);

    };

    this.saveOrUpdateUserPreferencesAndLogout = function () {
        
        var clearLocalStorageAndLogout = function (scope) {
            return function () {

                scope.clearLocalStorage();
                Monet.Authentication.logout();

            };
        }(this);

        this.saveOrUpdateUserPreferences(clearLocalStorageAndLogout);
    
    };

};
